import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthorizationModule } from 'app/core/authorization/authorization.module';
import { AuthorizationGuard } from './core/authorization/authorization.guard';
import { LoginComponent } from './core/authorization/login/login.component';
import { NotFoundComponent } from './core/authorization/not-found/not-found.component';
import { UnauthorizedComponent } from './core/authorization/unauthorized/unauthorized.component';

const appRoutes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'home',
    loadChildren: () => import('app/modules/home-area/home-area.module').then(m => m.HomeAreaModule),
    canActivate: [AuthorizationGuard],
  },
  {
    path: 'search',
    loadChildren: () => import('app/modules/search-area/search-area.module').then(m => m.SearchAreaModule),
    canActivate: [AuthorizationGuard],
  },
  {
    path: 'dossier',
    loadChildren: () => import('app/modules/dossier-area/dossier-area.module').then(m => m.DossierAreaModule),
    canActivate: [AuthorizationGuard],
  },
  {
    path: 'erfassungen',
    loadChildren: () => import('app/modules/erfassungen/erfassungen.module').then(m => m.ErfassungenModule),
    canActivate: [AuthorizationGuard],
  },
  {
    path: 'export',
    loadChildren: () => import('app/modules/export/export.module').then(m => m.ExportModule),
    canActivate: [AuthorizationGuard],
  },
  {
    path: 'import',
    loadChildren: () => import('app/modules/import/import.module').then(m => m.ImportModule),
    canActivate: [AuthorizationGuard],
  },
  {
    path: 'rules',
    loadChildren: () => import('app/modules/validation-rules/validation-rules.module').then(m => m.ValidationRulesModule),
    canActivate: [AuthorizationGuard],
  },
  {
    path: 'thesaurus',
    loadChildren: () => import('app/modules/thesaurus-rules/thesaurus-rules.module').then(m => m.ThesaurusRulesModule),
    canActivate: [AuthorizationGuard],
  },
  {
    path: 'lists',
    loadChildren: () => import('app/modules/favoritenlisten/favoritenlisten.module').then(m => m.FavoritenlistenModule),
    canActivate: [AuthorizationGuard],
  },
  {
    path: 'ranking',
    loadChildren: () => import('app/modules/ranking/ranking.module').then(m => m.RankingModule),
    canActivate: [AuthorizationGuard],
  },
  {
    path: 'psatz',
    loadChildren: () => import('app/modules/psatz-rules/psatz-rules.module').then(m => m.PSatzRulesModule),
    canActivate: [AuthorizationGuard],
  },
  {
    path: 'system-settings',
    loadChildren: () => import('app/modules/system-settings/system-settings.module').then(m => m.SystemSettingsModule),
    canActivate: [AuthorizationGuard],
  },
  {
    path: 'maintenance',
    loadChildren: () => import('app/modules/maintenance-window/maintenance-window.module').then(m => m.MaintenanceWindowModule),
    canActivate: [AuthorizationGuard],
  },
  {
    path: 'feedback',
    loadChildren: () => import('app/modules/feedback/feedback.module').then(m => m.FeedbackModule),
    canActivate: [AuthorizationGuard],
  },
  {
    path: 'lookuptables',
    loadChildren: () => import('app/modules/lookup-tables/lookup-tables.module').then(m => m.LookupTablesModule),
    canActivate: [AuthorizationGuard],
  },
  { path: '404', component: NotFoundComponent },
  { path: 'unauthorized', component: UnauthorizedComponent },
  { path: '**', redirectTo: '/404' },
];

@NgModule({
  imports: [AuthorizationModule, RouterModule.forRoot(appRoutes)],
  exports: [RouterModule],
  providers: [],
})
export class AppRoutingModule {}
